import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { LayoutDashboard } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { ReportBuilderPage } from "./pages/ReportBuilderPage";
import { ReportsListPage } from "./pages/ReportsListPage";
import { ReportViewPage } from "./pages/ReportViewPage";

export const reportsModule: FeatureModule = {
  key: "reports",
  nav: {
    label: "Reports",
    icon: LayoutDashboard,
    to: "/reports",
    // Any authenticated user may open Reports; the list + each report enforce
    // per-record access on the backend (reports.read sees all; everyone else
    // sees the reports they own or that were shared with them).
    requires: "",
    order: 124,
    group: "Tools",
  },
  routes: (rootRoute) =>
    [
      createRoute({
        getParentRoute: () => rootRoute,
        path: "/reports",
        component: guarded("", ReportsListPage),
      }),
      createRoute({
        getParentRoute: () => rootRoute,
        // The conversational builder (== editor). Per-record access is enforced
        // by the backend; the page shows a view-only notice to non-editors.
        path: "/reports/$reportId",
        component: guarded("", ReportBuilderPage),
      }),
      createRoute({
        getParentRoute: () => rootRoute,
        // The dashboard viewer — read-only render of saved panels; editors can
        // also rearrange here. Access enforced by the backend.
        path: "/reports/$reportId/view",
        component: guarded("", ReportViewPage),
      }),
    ] as unknown as AnyRoute[],
};
